import { useObservedQuery } from 'hooks/useObservedQuery';
import React, { useEffect, useState } from 'react'
import { Sort, SortProps } from 'routers/types';

export const SortFilters: React.FC = () => {
    const { data, updateFilters, sortOptions } = useObservedQuery();
    const [currFilters, setCurrentFilters] = useState<SortProps>({} as SortProps);
    const [apply, setApply] = useState(false);

    useEffect(() => {
        if (sortOptions) setCurrentFilters(sortOptions)
    }, [sortOptions, data])

    useEffect(() => {
        if (apply) {
            updateFilters(currFilters)
            setApply(false)
        }
    }, [currFilters, apply])

    const renderSortDropdown = () => {
        return (
            <div className="relative flex items-center">
                <i className="far fa-arrow-down-arrow-up"></i>
                <select
                    className="dark:bg-custom-900 bg-none text-end text-sm border-none focus:outline-none focus:ring-0 p-0 focus:border-transparent !appearance-none"
                    onChange={(e) => {
                        setCurrentFilters({
                            ...currFilters,
                            sort: e.target.value as Sort,
                        });
                        setApply(true);
                    }}
                    value={currFilters?.sort}
                >
                    <option value="totalPriceDesc">Price High - Low</option>
                    <option value="totalPriceAsc">Price Low - High</option>
                    <option value="vehicleAgeDesc">Age Newest - oldest</option>
                    <option value="vehicleAgeAsc">Age Oldest - Newest</option>
                    <option value="odometerReadingMilesDesc">Mileage High - Low</option>
                    <option value="odometerReadingMilesAsc">Mileage Low - High</option>
                    <option value="myFavourites">My Favorites</option>
                    {/* <option value="recent">Recently Listed</option> */}
                </select>
            </div>
        );
    };


    return (
        <div className='flex'>
            {renderSortDropdown()}
        </div>
    );
}